import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { SearchContext } from '.';
import { Input } from '@/components/common';
import { SIDEBAR_DELAY } from '@/config/variables';
import { Search } from '@/assets/icons';
import { media } from '@/styles/theme';

const ResourcesFilter = (): React.ReactElement => {
  const { t } = useTranslation();
  const { setSearch } = useContext(SearchContext);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch && setSearch(event.target.value);
  };

  return (
    <Container>
      <Input
        type="text"
        name="filterFolder"
        className="resources-filter"
        placeholder={t`resources.leftPanel.placeholderSearch`}
        onChange={handleOnChange}
      />
    </Container>
  );
};

export { ResourcesFilter };

const Container = styled.div`
  transition: opacity ${SIDEBAR_DELAY}ms ease-in-out;

  .collapsed & {
    opacity: 0;
  }

  .resources-filter input {
    background-image: url(${Search});
    background-repeat: no-repeat;
    background-position: 95% center;
    height: 36px;

    ${media.phone} {
      height: 48px;
    }
  }
`;
